import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "facet-radio" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "facet-radio-mark",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["id", "name", "value", "checked"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "facet-radio-mark",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_6 = ["for"]
const _hoisted_7 = ["innerHTML"]

import { SolrFacet, SolrFacetOption } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import { onMounted, ref } from 'vue'; // eslint-disable-line import/no-relative-parent-imports


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetOptionsCheckbox',
  props: {
    facet: {}
  },
  emits: ["changeMultiple"],
  setup(__props: any, { emit }) {

const props = __props;



const selectedValues = ref([] as string[]);



function key (option: SolrFacetOption): string {
    return `${option.label}|${option.value}|${option.selected ? 'y' : 'n'}}`;
}

function changeMultipleValue (event: Event): void {
    const value = decodeURIComponent((event.target as HTMLInputElement).value);
    if (selectedValues.value.includes(value)) {
        const index = selectedValues.value.indexOf(value);
        selectedValues.value.splice(index, 1);
    } else {
        selectedValues.value.push(value);
    }
    emit('changeMultiple', props.facet.name, selectedValues.value);
}

onMounted((): void => {
    for (const [key, option] of Object.entries(props.facet.options)) {
        if (option.selected) {
            selectedValues.value.push(decodeURIComponent(option.value));
        }
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(`facet-type-${props.facet.field.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", {
        class: "facet-label",
        innerHTML: decodeURIComponent(props.facet.label)
      }, null, 8 /* PROPS */, _hoisted_3)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.facet.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key(option),
        class: "facet-radio facet-radio-child"
      }, [
        _createElementVNode("input", {
          id: 'facet-' + props.facet.name + '-' + option.value,
          type: "checkbox",
          class: "visually-hidden",
          name: props.facet.name,
          value: option.value,
          checked: option.selected,
          onChange: changeMultipleValue
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
        _hoisted_5,
        _createElementVNode("label", {
          for: 'facet-' + props.facet.name + '-' + option.value
        }, [
          _createElementVNode("span", {
            innerHTML: decodeURIComponent(option.label)
          }, null, 8 /* PROPS */, _hoisted_7)
        ], 8 /* PROPS */, _hoisted_6)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})